import {
  finalizedResultsExistUrl,
  finalizeResultsUrl,
  getAssignmentByIdUrl,
  getAssignmentResultsUrl,
  getAssignmentsByPlanId,
  getAssignmentsBySectionUrl,
  getFacultiesUrl,
} from "../config/Config";
import { getRequest, putRequest } from "./ServiceHelper";

export class AssignmentService {
  static ASSIGNMENT = "assignment";
  static ROLLUP = "rollup";

  static getAssignmentsByPlanId = (planId) => {
    return getRequest(getAssignmentsByPlanId(planId));
  };

  static getAssignmentByFacultyId = (facultyId) => {
    return getRequest(getFacultiesUrl() + "/" + facultyId + "/assignments");
  };

  static getAssignmentResults = (id) => {
    const params = { assignmentId: id };
    return getRequest(getAssignmentResultsUrl(), params);
  };

  static getAssignmentById = (id) => {
    return getRequest(getAssignmentByIdUrl(id));
  };

  static getAssignmentsBySectionId = (canvasSectionId) => {
    return getRequest(getAssignmentsBySectionUrl(canvasSectionId));
  };

  static getResultsByContext = (mode, contextId) => {
    return getRequest(finalizeResultsUrl(mode, contextId));
  };

  static finalizeResultsByContext = ({
    mode,
    contextId,
    roundingMode,
    data,
    bulkTaskId,
  }) => {
    const params = {};
    if (roundingMode) {
      params.roundingMode = roundingMode;
    }
    if (bulkTaskId) {
      params.bulkTaskId = bulkTaskId;
    }

    const body = { data: data };
    const withCredentials = true;
    const ignoreRedirect = false;
    const ignoreJson = false;
    const signal = null;

    return putRequest(
      finalizeResultsUrl(mode, contextId),
      body,
      withCredentials,
      ignoreRedirect,
      ignoreJson,
      signal,
      params
    );
  };

  static getFinalizedResultsExist = (contextId, taskId = null) => {
    const params = {};
    if (taskId) {
      params["taskId"] = taskId;
    }

    return getRequest(finalizedResultsExistUrl(contextId), params);
  };
}
